const styles = (theme: any) => ({
  '@keyframes expand_rr_notification': {
    from: {
      width: '50px',
    },
    to: {
      width: 'var(--expanded-width, 100px)',
    },
  },
  '@keyframes collapse_rr_notification': {
    from: {
      width: 'var(--expanded-width, 100px)',
    },
    to: {
      width: '50px',
    },
  },
  cardNotificationContainerCollapsed: {
    position: 'absolute',
    top: '-10px',
    right: '-17px',
    zIndex: '10',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'no-wrap',
    height: '27px',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.colors.warning}`,
    borderRadius: '100px 0 0 100px',
    backgroundColor: theme.colors.warning,
    boxShadow: '-1px 1px 2px 0 rgba(0,0,0,0.2)',
    paddingLeft: '10px',
    paddingRight: '10px',
    overflow: 'hidden',
  },
  notificationExpand: {
    animationDuration: '0.5s',
    animationName: 'expand_rr_notification',
  },
  notificationCollapse: {
    animationDuration: '0.5s',
    animationName: 'collapse_rr_notification',
  },
  notificationText: {
    fontSize: '13px',
    lineHeight: '13px',
    color: theme.colors.textSecondary,
    flexShrink: '0',
    marginRight: '15px',
  },
  editBid: {
    color: theme.colors.primary,
    fontSize: theme.fontSize.small,
    letterSpacing: '0',
    lineHeight: '12px',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    flexShrink: '0',
    marginRight: '15px',
  },
  noThanks: {
    color: theme.colors.textTertiary,
    fontSize: theme.fontSize.small,
    letterSpacing: '0',
    lineHeight: '12px',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    flexShrink: '0',
    marginRight: '10px',
  },
  close: {
    fontSize: '18px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styles;
